export const FileManagerTypes = {
    OPEN_CLOSE_WINDOW : 'OPEN_CLOSE_WINDOW_FILE_MANAGER',
    SET_FILES : 'SET_FILES_FILE_MANAGER',
    RESET : 'RESET'
};